import React, { useEffect } from 'react'
import Gurudev_banner from './gurudev-banner/Gurudev_banner'
import Gurudev_content from './gurudev-content/Gurudev_content'
import Quote_of_day from '../home/quote-of-day/Quote_of_day'
import Core_vision from './core-vision/Core_vision'
import Recent_update from './recent-update/Recent_update'
import Pravachan from './pravachan/Pravachan'
import Vishvakalyan from './vishvakalyan/Vishvakalyan'
import { useDispatch, useSelector } from 'react-redux'
import { GurudevContent } from '../../features/admin/common/Slice'
import { IDS } from '../../utils/IDS'

const Gurudev = () => {


    const dispatch = useDispatch();
    const content = useSelector((state) => state.common.gurudev_content);

    useEffect(() => {
        dispatch(GurudevContent({ pod_status: true }));
    }, [dispatch]);

    return (
        <>
            <Gurudev_banner image={IDS.IMG_URL + content?.Gurudev_Content?.image} />
            <Gurudev_content content={content} />
            <Quote_of_day />
            <Core_vision />
            <Recent_update />
            <Pravachan />
            <Vishvakalyan />
        </>
    )
}

export default Gurudev